import PurposesTabContent from './PurposesTabContent'

export default PurposesTabContent
